import React from 'react';

const TransparencySection = () => {
  return (
    <div className="bg-white p-8 flex flex-col items-center text-white">
      <div className="max-w-6xl mx-auto text-left w-full">
        
        <h2 className="text-3xl md:text-4xl text-blue-900 font-bold mb-6">Projetos que precisam da sua ajuda</h2>
        
        <p className="text-base md:text-lg mb-8 text-blue-900 leading-relaxed">
            Ao ajudar a Keralty, você apoia projetos que unem saúde, educação e assistência social em um modelo de cuidado integral. Sua contribuição fortalece serviços comunitários, suporte a pessoas em situação de vulnerabilidade e ações transformadoras que promovem dignidade, bem-estar e esperança.
        </p>
        
      </div>
    </div>
  );
};

export default TransparencySection;